import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { LoansService } from 'src/app/_services/loans.service';
import { StorageService } from 'src/app/_services/storage.service';
@Component({
  selector: 'app-latestmerchants',
  templateUrl: './latestmerchants.component.html',
  styleUrls: ['./latestmerchants.component.css']
})
export class LatestmerchantsComponent implements OnInit {

  user:any;
  currentLoan=[];
  constructor(private storageService: StorageService, private loansService: LoansService, private authService: AuthenticationService) { 
    this.user = this.storageService.read<any>('user');
  }

  ngOnInit() {
    this.getCurrentLoans();
  }
  getCurrentLoans() {

    //this.loading = true; 
    this.loansService.latestmerchants()
      .subscribe(result => {
         this.currentLoan = result.data.currentLoan;
      }, err => { 
      });
  }
}
